/**
 * Copy de la página de Buenos Aires, transcrito de `DEMO_1_BuenosAires.png`.
 *
 * Lo que NO está aquí y sale de `src/features/events` (ADR-003): ciudad, fechas,
 * título del evento, acento script, beneficios, programa (con sus horas reales)
 * y estado de venta. Esta página no teclea ni un dato de la gira.
 *
 * Erratas del generador de imagen corregidas (ver docs/VISUAL_DEVIATIONS.md §2):
 *  · "CRENCIAS" -> "CREENCIAS"   · "AOGR" -> AΩGR
 *  · acentos restituidos: DESPROGRAMACIÓN, PERCEPCIÓN, PRÓXIMAMENTE, AUTOMAESTRÍA
 */

export const BA_META = {
  documentTitle: 'Buenos Aires · Desprogramación de la Percepción',
  description:
    'Buenos Aires, 6 y 7 de febrero de 2027. Dos días de inmersión para romper el motor del ego, desprogramar la percepción y recuperar tu automaestría, con la Cámara Cuántica Pleyadiana.',
} as const;

export const BA_HERO = {
  /** El bloque de marca del hero es el enlace de vuelta al hub (desviación B-1). */
  homeLinkLabel: 'Ir a la portada de la gira',
  /** "DE LA" va entre las dos líneas grandes, flanqueado por dos filetes. */
  titleConnector: 'de la',
  obeliscoAlt: 'El Obelisco de Buenos Aires contra un cielo luminoso',
  banderaAlt: 'Bandera argentina de seda ondeando con el Sol de Mayo',
  portraitAlt: 'Azrahel del Mayor, de camisa blanca, mirando a la izquierda',
} as const;

export const BA_PROGRAM = {
  title: 'Programa – 2 días de inmersión',
  /** Etiqueta del domingo, que tiene un bloque único de 10:30 a 13:30. */
  singleBlockLabel: 'Bloque único',
} as const;

export const BA_CHAMBER = {
  title: 'Cámara Cuántica',
  paragraphs: [
    'Una experiencia inmersiva y transformadora que acelera tu salto evolutivo.',
    'Activa tu cuerpo de luz. Reescribe tu realidad.',
  ] as const,
  imageAlt: 'Domo geodésico de cristal y oro sobre una plataforma circular, reflejado en agua en calma',
} as const;

export const BA_AZRAHEL = {
  /** El mockup de Buenos Aires rotula solo "AZRAHEL", sin "del Mayor". */
  name: 'Azrahel',
  paragraphs: [
    'Guía y mentor espiritual. Transmisor de la sabiduría Pleyadiana.',
    'Más de tres décadas acompañando a buscadores en el despertar de la conciencia y la maestría del Ser.',
    'Su trabajo integra enseñanzas ancestrales y herramientas cuánticas para la transformación real y la expansión del alma.',
  ] as const,
  portraitAlt: 'Retrato de Azrahel del Mayor en recorte circular',
  stairwayAlt: 'Escalera de piedra blanca ascendiendo hacia nubes luminosas',
} as const;

export const BA_TICKETS = {
  title: 'Entradas',
  banderaAlt: 'Franja de la bandera argentina con el Sol de Mayo',
} as const;
